// extracted by mini-css-extract-plugin
export default {"container":"FrequencyIcon_container__DuiEi","l":"FrequencyIcon_l__gbEvt","s":"FrequencyIcon_s__5TqE9","xl":"FrequencyIcon_xl__3KM+U"};